import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import PageHeaderButtonsWrapper from "../../shared/components/page/page-header/page-header-buttons-wrapper";
import TemplateCreator from "../template-creator";
const TemplatesTopActions = () => {
    return (_jsx(PageHeaderButtonsWrapper, { children: _jsx(TemplateCreator, {}) }));
};
export default TemplatesTopActions;
